import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SemiPieChart from "../../common/SemiPieChart";
import ColumnChart from "../../common/ColumnChart";
import DataTableBase from "../../common/DateTableBase";
import { useNavigate } from "react-router-dom";
import { FaBahtSign } from "react-icons/fa6";
import axios from "axios";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";
import Header from "../../common/Header";

const Overview = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [user, setUser] = useState();
    const [data, setData] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Profile res : ", res);

            //Check money
            console.log("Money : ", res?.data?.user?.money);
            //Check point
            console.log("Points : ", res?.data?.user?.points);

            // setStaffList(res?.data?.staffList);
            setUser(res?.data?.user);
            // setUser(res?.data?.billInfo);
            setLoading(false);
        }).catch((err) => {
            // console.log("Profile error : ", err);
            setLoading(false);
        })
    }, [])

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/overview`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Overview res : ", res);
            console.log("Data : ", res?.data?.data);
            // setStaffList(res?.data?.staffList);
            // setUser(res?.data?.user);
            // setUser(res?.data?.billInfo);
            setData(res?.data?.data);
            setLoading2(false);
        }).catch((err) => {
            console.log("Overview error : ", err);
            setLoading2(false);
        })
    }, [])

    const TOP10Allocation = [
        {
            name: <span className="tableHeaderText">No.</span>,
            width: '70px',
            selector: (row, index) => index + 1,
        },
        {
            name:  <span className="tableHeaderText">VCard</span>,
            selector: row => row?.staff_vcard,
        },
        {
            name: <span className="tableHeaderText">Status</span>,
            selector: row => row?.status === "Success"? <span className="active-status">Success</span>
             : row?.status === "Pending" ? <span className="text-warning">Pending</span>
             : <span className="inactive-status">Failed</span>,
        },
        {
            name: <span className="tableHeaderText">Points</span>,
            selector: row => (Number(row?.fund_transfer)).toLocaleString(),
        }
    ];

    const recentAllocation = [
        {
            name: <span className="tableHeaderText">No.</span>,
            width: '70px',
            selector: (row, index) => index + 1,
        },
        {
            name:  <span className="tableHeaderText">VCard</span>,
            selector: row => row?.staff_vcard,
        },
        {
            name: <span className="tableHeaderText">Status</span>,
            selector: row => row?.status === "Success"? <span className="active-status">Success</span>
             : row?.status === "Pending" ? <span className="text-warning">Pending</span>
             : <span className="inactive-status">Failed</span>,
        },
        {
            name: <span className="tableHeaderText">Points</span>,
            selector: row => (Number(row?.fund_transfer)).toLocaleString(),
        }
    ];

    const data1 = [
        // {
        //     id: 1,
        //     status: 1,
        //     staff: 'Staff A',
        //     total: '50,000'
        // },
        // {
        //     id: 2,
        //     status: 1,
        //     staff: 'Staff B',
        //     total: '35,000'
        // },
        // {
        //     id: 3,
        //     status: 0,
        //     staff: 'Staff C',
        //     total: '55,000'
        // },
        // {
        //     id: 5,
        //     status: 1,
        //     staff: 'Staff D',
        //     total: '55,000'
        // },
        // {
        //     id: 6,
        //     status: 1,
        //     staff: 'Staff E',
        //     total: '55,000'
        // },
        // {
        //     id: 7,
        //     status: 0,
        //     staff: 'Staff G',
        //     total: '55,000'
        // },
        // {
        //     id: 8,
        //     status: 1,
        //     staff: 'Staff H',
        //     total: '85,000'
        // },
    ]

    const data2 = [
        // {
        //     numb: '#1wq87sc6',
        //     staff: 'Staff A',
        //     status: 1,
        //     fund: 500,
        // },
        // {
        //     numb: '#2ssa8adf2s',
        //     staff: 'Staff B',
        //     status: 0,
        //     fund: 500,
        // },
        // {
        //     numb: '#1wq87sc6',
        //     staff: 'Staff C',
        //     status: 1,
        //     fund: 500,
        // },
        // {
        //     numb: '#1wq87sc6',
        //     staff: 'Staff D',
        //     status: 0,
        //     fund: 500,
        // },
        // {
        //     numb: '#1wq87sc6',
        //     staff: 'Staff E',
        //     status: 1,
        //     fund: 500,
        // },
        
    ];


    if(loading && loading2){
        return (
            <Loader />
        )
    } else {
        return (
            <div className="overview">
                {/* <Header /> */}
                <h1 className="overviewText mt-3 pb-4">Overview</h1>
                <Row>
                    <Col md={12} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Total Balance</h2>
                            <p>{Number((12345 + Number(user?.points)).toFixed(2)).toLocaleString()} <span>THB</span> </p>
                        </div>
                    </Col>
                    <Col md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Allocated Balance</h2>
                            <p>{(Number(user?.points).toLocaleString())} <span>THB</span> </p>
                        </div>
                    </Col>
                    <Col md={6} xl={4} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="statTextBox">
                            <h2>Unallocated Balance</h2>
                            <p>12345 <span>THB</span> </p>  {/* Endpoint for this is now unknwown */}
                        </div>
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center align-items-center mt-3 mb-2">
                        <div className="ratioBox">
                            <h2>Allocation Ratio</h2>
                            <div class="ratiobarContainer">
                                <div class="ratiobarFill" style={{ width: `${(Number(user?.points)) / (Number(user?.points) + 12345) * 100}%` }}></div>
                            </div>
                            <div class="ratiobarLabels">
                                <span>Allocated ({((Number(user?.points)) / (Number(user?.points) + 12345) * 100).toFixed(2)}%)</span>
                                <span>Unallocated ({((12345) / (Number(user?.points) + 12345) * 100).toFixed(2)}%)</span>
                            </div>
                        </div>
                    </Col>

                    {/* Point Chart */}
                    <Col md={12}>
                        {/* <h2 className="overview-t6">Points Allocated Chart</h2> */}
                        <h2 className="barChartHeader">Total Point Chart</h2>
                        <ColumnChart 
                            data={data?.totalGraphSpend ? data?.totalGraphSpend : []} 
                            data2={data?.monthlyFundRequests ? data?.monthlyFundRequests : []} />
                    </Col>
                    
                    {/* Tables */}
                    <Col lg={12} xl={6} style={{ padding: '16px 16px 0 12px' }}>
                        <div className="overview-table-div">
                            <div className="headerWrapper d-flex justify-content-between align-items-center pb-4">
                                <h2 className="chartTableHeader d-flex align-items-center">
                                    <svg  fill="#000000" xmlns="http://www.w3.org/2000/svg" width="33.75" height="30" viewBox="418 965.832 33.75 30"><path d="M450.344 969.582h-6.094v-2.344c0-.779-.627-1.406-1.406-1.406h-15.938c-.779 0-1.406.627-1.406 1.406v2.344h-6.094c-.779 0-1.406.627-1.406 1.406v3.282c0 2.091 1.318 4.242 3.627 5.9 1.846 1.33 4.09 2.174 6.445 2.443 1.84 3.053 3.99 4.313 3.99 4.313v4.219h-2.812c-2.068 0-3.75 1.212-3.75 3.28v.704c0 .387.316.703.703.703h17.344a.705.705 0 0 0 .703-.703v-.703c0-2.069-1.682-3.281-3.75-3.281h-2.813v-4.22s2.15-1.259 3.99-4.312c2.362-.27 4.606-1.113 6.446-2.443 2.303-1.658 3.627-3.809 3.627-5.9v-3.282c0-.779-.627-1.406-1.406-1.406Zm-26.526 7.547c-1.43-1.031-2.068-2.18-2.068-2.86v-.937h3.762c.058 1.91.34 3.586.75 5.05a9.443 9.443 0 0 1-2.444-1.253Zm24.182-2.86c0 .944-1.037 2.116-2.068 2.86a9.48 9.48 0 0 1-2.45 1.254c.41-1.465.692-3.14.75-5.051H448v.938Z" fill-rule="evenodd" data-name="Icon awesome-trophy"/></svg>
                                    TOP 10 Allocation
                                </h2>
                                <button className="pointerButton" onClick={() => navigate('/charging-report')}>
                                    <span className="pointer d-flex align-items-center">Report</span>
                                </button>
                            </div>
                            <DataTableBase 
                                columns={TOP10Allocation} 
                                data={data?.top10Allocations ? data?.top10Allocations : []} />
                        </div>
                    </Col>
                    <Col lg={12} xl={6} style={{ padding: '16px 12px 0 16px' }}>
                        <div className="overview-table-div">
                            <div className="headerWrapper d-flex justify-content-between align-items-center pb-4">
                                <h2 className="chartTableHeader d-flex align-items-center">
                                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="33.75" height="33.75" viewBox="15 19 63 63"><path d="M28.1 48c-.1.7-.1 1.3-.1 2h-6c0-.7 0-1.3.1-2zm23.4-12h-3c-.8 0-1.5.7-1.5 1.5v13.1c0 .4.2.8.4 1.1l8.4 8.4c.6.6 1.5.6 2.1 0L60 58c.6-.6.6-1.5 0-2.1l-7-7.1V37.5c0-.8-.7-1.5-1.5-1.5"/><path d="M50 22c-14.8 0-26.9 11.5-27.9 26 0 .3-.1.7-.1 1h-4.5c-1.3 0-2 1.5-1.2 2.4l7.5 9.1c.6.7 1.7.7 2.3 0l7.5-9.1c.8-1 .1-2.4-1.2-2.4H28v-1c1-11.2 10.5-20 21.9-20 13 0 23.3 11.3 21.9 24.5-1 9.5-10 18.5-19.6 19.4-7.1.7-13.8-1.9-18.5-7-.6-.7-1.4-1.1-2.2-.1l-2.4 2.9c-.5.6-.1 1 .4 1.5 5.4 5.7 12.8 8.9 20.8 8.8 14.4-.2 26.5-11.6 27.5-26C79.1 35.7 66.1 22 50 22"/></svg>
                                    Recent Allocation 
                                </h2>
                                <button className="pointerButton" onClick={() => navigate(`/fund-requests`)}>
                                    <span className="pointer d-flex align-items-center">View all</span>
                                </button>
                            </div>
                            <DataTableBase 
                                columns={recentAllocation} 
                                data={data?.last10Allocations ? data?.last10Allocations : []} />
                        </div>
                    </Col>  
                </Row>
            </div>
        )
    }
}

export default Overview;